import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { ToastrService } from 'ngx-toastr'
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs'
import {
  selectCouponActiveCount,
  selectCouponAnalytics,
  selectCouponExpiredCount,
  selectCouponInactiveCount,
  selectCouponLoading,
  selectCoupons,
  selectCouponTotalCount
} from '../../../store/coupon/coupon.selectors'
import {
  createCoupon,
  deleteCoupon,
  loadCouponAnalytics,
  loadCoupons,
  updateCoupon
} from '../../../store/coupon/coupon.actions'
import { Coupon, CouponListResponse } from '../../../store/coupon/coupon.state'
import { CommonModule } from '@angular/common'
import { PaginationComponent } from '../template/pagination/pagination.component'
import { FormatModuleNamePipe } from '../../../pipes/format-module-name.pipe'
import { TrimInputDirective } from '../../../directives/trim-input.directive'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'

@Component({
  selector: 'app-coupon',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    PaginationComponent,
    FormatModuleNamePipe,
    TrimInputDirective,
    CapitalizePipe
  ],
  templateUrl: './coupon.component.html',
  styleUrl: './coupon.component.scss'
})
export class CouponComponent implements OnInit {
  store = inject(Store)
  modalService = inject(NgbModal)
  fb = inject(FormBuilder)
  form!: FormGroup
  @ViewChild('addCouponModal') addCouponModal!: TemplateRef<any>
  @ViewChild('deleteModal') deleteModal!: TemplateRef<any>
  toastr = inject(ToastrService)
  analytics = { totalCoupons: 0, activeCoupons: 0, inactiveCoupons: 0, noOfCouponTypes: 0 }
  operation = ''
  selectedCoupon: Coupon | null = null
  selectedCouponType: 'monthly' | 'yearly' | null = null
  selectedCouponStatus: 'active' | 'inactive' | null = null
  currentPage = 1
  pageLimit = 10
  search = ''
  private searchSubject = new Subject<string>()

  totalCount = 0
  pageLastRecord = this.pageLimit

  coupons$ = this.store.select(selectCoupons)
  loading$ = this.store.select(selectCouponLoading)
  totalCount$ = this.store.select(selectCouponTotalCount)
  analytics$ = this.store.select(selectCouponAnalytics)
  activeCount$ = this.store.select(selectCouponActiveCount)
  inactiveCount$ = this.store.select(selectCouponInactiveCount)
  expiredCount$ = this.store.select(selectCouponExpiredCount)
  constructor() {}
  ngOnInit() {
    this.initializeForm()
    this.getCoupons()
    // this.getAnalytics()

    // this.store.dispatch(loadCouponAnalytics())

    this.searchSubject.pipe(debounceTime(500), distinctUntilChanged()).subscribe(searchValue => {
      this.search = searchValue
      this.currentPage = 1
      this.getCoupons()
    })

    this.totalCount$.subscribe(count => {
      this.totalCount = count // Define this.totalCount in your class
    })
  }

  // initializeForm() {
  //   this.form = this.fb.group({
  //     id: [null],
  //     name: ['', Validators.required],
  //     type: ['yearly', Validators.required],
  //     position: [null, Validators.required],
  //     minimumLicences: [1, [Validators.required, Validators.min(1)]],
  //     price: [0, [Validators.required, Validators.min(0)]],
  //     currencyId: [5, Validators.required],
  //     discountType: ['percentage', Validators.required],
  //     discountValue: [0, [Validators.required, Validators.min(0)]],
  //     // availableFeatures: this.fb.array(this.allPossibleFeatures.map(() => this.fb.control(false))),
  //     trialDays: [0, [Validators.required, Validators.min(0)]],
  //     isRecommended: [false, Validators.required],
  //     isActive: [true, Validators.required],
  //     description: [''],
  //     gst: [0, [Validators.required, Validators.min(0)]]
  //   })
  //   // Listen for changes in the Coupon type dropdown
  //   this.form.get('type')?.valueChanges.subscribe(() => {
  //     this.updateAvailablePositions(this.selectedCoupon)
  //     // Reset position when type changes to avoid invalid position selection
  //     this.form.get('position')?.setValue(null)
  //   })
  // }

  initializeForm() {
    this.form = this.fb.group(
      {
        id: [null],

        code: ['', Validators.required],

        name: ['', Validators.required],

        description: [''],

        discountType: ['percentage', Validators.required],

        discountValue: [0, [Validators.required, Validators.min(0)]],

        maxDiscount: [null],

        minimumOrder: [0, [Validators.required, Validators.min(0)]],

        usageLimit: [null],

        usageLimitPerUser: [1, [Validators.required, Validators.min(1)]],

        startDate: ['', Validators.required],

        expiryDate: ['', Validators.required],

        status: ['active'],

        isFirstOrderOnly: [false]
      },
      {
        validators: [discountValidator, startDateValidator, dateRangeValidator]
      }
    )
  }

  get featuresFormArray(): FormArray {
    return this.form.get('availableFeatures') as FormArray
  }

  // getAnalytics() {
  //   this.store.dispatch(loadCouponAnalytics())
  // }

  getCoupons() {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }

    if (this.search) {
      params.search = this.search
    }

    if (this.selectedCouponStatus) {
      params.status = this.selectedCouponStatus
    }

    this.store.dispatch(
      loadCoupons({
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit,
        context: 'list'
      })
    )
  }

  openModal(modal: TemplateRef<any>) {
    this.operation = 'Add'
    this.selectedCoupon = null
    this.initializeForm()
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'lg'
    })
  }

  //10 march 2026
  openEditModal(coupon: Coupon, modal: TemplateRef<any>) {
    this.operation = 'Edit'
    this.selectedCoupon = coupon

    this.initializeForm()

    this.form.patchValue({
      ...coupon,
      startDate: coupon.startDate ? this.formatDate(coupon.startDate) : '',
      expiryDate: coupon.expiryDate ? this.formatDate(coupon.expiryDate) : ''
    })

    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'lg'
    })
  }

  openDeleteModal(coupon: Coupon, modal: TemplateRef<any>) {
    this.selectedCoupon = coupon
    this.modalService.open(modal, { centered: true })
  }

  closeModal() {
    this.operation = ''
    this.selectedCoupon = null
    this.modalService.dismissAll()
  }

  upsertCoupon() {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    const params = ''
    const { id, ...payload } = this.form.value

    payload.discountValue = Number(payload.discountValue)
    payload.maxDiscount = payload.maxDiscount ? Number(payload.maxDiscount) : null
    payload.minimumOrder = Number(payload.minimumOrder)
    payload.usageLimit = payload.usageLimit ? Number(payload.usageLimit) : null
    payload.usageLimitPerUser = Number(payload.usageLimitPerUser)

    if (this.operation === 'Add') {
      this.store.dispatch(createCoupon({ coupon: payload }))
    } else {
      // this.store.dispatch(
      //   updateCoupon({
      //     id,
      //     coupon: payload
      //   })
      // )

      this.store.dispatch(
        updateCoupon({
          id,
          coupon: payload,
          params: new URLSearchParams(params).toString(),
          page: this.currentPage,
          limit: this.pageLimit
        })
      )
    }

    this.closeModal()
  }

  confirmDelete() {
    if (!this.selectedCoupon) {
      this.toastr.error('No Coupon selected for deletion.')
      this.closeModal()
      return
    }
    this.store.dispatch(
      deleteCoupon({
        id: this.selectedCoupon.id
      })
    )
    this.closeModal()
  }

  onFilterChange(resetPage = false) {
    if (resetPage) this.currentPage = 1
    this.getCoupons()
  }

  onSearchChange(searchValue: string) {
    this.searchSubject.next(searchValue)
  }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.getCoupons() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.getCoupons() // Load employees with new page limit
  }

  onCouponCodeInput(): void {
    const control = this.form.get('code')

    if (!control) return

    const value = control.value ?? ''
    control.setValue(value.toUpperCase(), { emitEvent: false })
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)

    if (!control || !control.errors || !(control.touched || control.dirty)) {
      return null
    }

    const errors = control.errors

    if (errors['required']) {
      return 'This field is required.'
    }

    if (errors['email']) {
      return 'Please enter a valid email address.'
    }

    if (errors['minlength']) {
      return `Minimum ${errors['minlength'].requiredLength} characters required.`
    }

    if (errors['maxlength']) {
      return `Maximum ${errors['maxlength'].requiredLength} characters allowed.`
    }

    if (errors['min']) {
      return `Value must be greater than or equal to ${errors['min'].min}.`
    }

    if (errors['max']) {
      return `Value must be less than or equal to ${errors['max'].max}.`
    }

    if (errors['pattern']) {
      return 'Invalid format.'
    }

    // Custom Validators
    if (errors['maxDiscountExceeded']) {
      return 'Maximum discount cannot be greater than minimum order.'
    }

    if (errors['startDatePast']) {
      return 'Start date cannot be in the past.'
    }

    if (errors['invalidDateRange']) {
      return 'Expiry date must be after start date.'
    }

    return 'Invalid value.'
  }

  getFormError(): string | null {
    const errors = this.form.errors

    if (!errors) return null

    if (errors['maxDiscountExceeded']) {
      return 'Maximum discount cannot be greater than minimum order.'
    }

    if (errors['startDatePast']) {
      return 'Start date cannot be in the past.'
    }

    if (errors['invalidDateRange']) {
      return 'Expiry date must be after start date.'
    }

    return null
  }

  // private formatDate(date: string | Date): string {
  //   return new Date(date).toISOString().split('T')[0]
  // }

  private formatDate(date: string | Date): string {
    const d = new Date(date)

    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }
}

export const discountValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const maxDiscount = control.get('maxDiscount')?.value
  const minimumOrder = control.get('minimumOrder')?.value

  if (maxDiscount != null && minimumOrder != null && +maxDiscount > +minimumOrder) {
    return { maxDiscountExceeded: true }
  }

  return null
}

export const startDateValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const startDate = control.get('startDate')?.value

  if (!startDate) return null

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const selectedDate = new Date(startDate)
  selectedDate.setHours(0, 0, 0, 0)

  return selectedDate < today ? { startDatePast: true } : null
}

export const dateRangeValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const startDate = control.get('startDate')?.value
  const expiryDate = control.get('expiryDate')?.value

  if (!startDate || !expiryDate) return null

  return new Date(expiryDate) < new Date(startDate) ? { invalidDateRange: true } : null
}
